import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=231e1c6d&"
import script from "./AdministrationPage.vue?vue&type=script&lang=ts&"
export * from "./AdministrationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports